module.exports = "/assets/3f678302424da1997ba273402bfe8ad5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/A6.png
// module id = 1184
// module chunks = 0